/* =====================================================================
 * 가이드 목차 모델 — 사이드바 항목을 가이드 목차 항목으로 옮긴 형태.
 * ===================================================================== */

import type { WorkspaceMode } from '@auw/workspace-utils';

export interface GuideEntry {
  /** `USER_GUIDE_DOCS` 조회 키이자 선택 상태 식별자. */
  readonly key: string;
  readonly label: string;
  /** 워크스페이스 모드 항목이면 그 모드. */
  readonly mode?: WorkspaceMode;
}

export interface GuideSection {
  readonly key: string;
  readonly title: string;
  readonly entries: readonly GuideEntry[];
}

export const modeEntry = (mode: WorkspaceMode, label: string): GuideEntry => ({
  key: `mode:${mode}`,
  label,
  mode,
});
